import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    Checkbox,
    ListItemButton,
    Divider,
    FormControlLabel,
    Box,
} from "@mui/material";

const UnhideDialog = ({ open, onClose, hiddenItems, onUnhide, entityType = "items" }) => {
    const [selectedIds, setSelectedIds] = useState([]);

    const allSelected = hiddenItems.length > 0 && selectedIds.length === hiddenItems.length;
    const someSelected = selectedIds.length > 0 && selectedIds.length < hiddenItems.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedIds(hiddenItems.map((item) => item.id));
        } else {
            setSelectedIds([]);
        }
    };

    const handleToggle = (id) => {
        const currentIndex = selectedIds.indexOf(id);
        const newSelected = [...selectedIds];

        if (currentIndex === -1) {
            newSelected.push(id);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        setSelectedIds(newSelected);
    };

    const handleUnhide = () => {
        if (selectedIds.length > 0) {
            onUnhide(selectedIds);
            setSelectedIds([]);
            onClose();
        }
    };

    const handleClose = () => {
        setSelectedIds([]);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Hidden {entityType}</DialogTitle>
            <DialogContent>
                {hiddenItems.length === 0 ? (
                    <div style={{ padding: "16px", textAlign: "center", color: "#666" }}>
                        No hidden {entityType} found
                    </div>
                ) : (
                    <>
                        <Box sx={{ px: 1, py: 0.5 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={allSelected}
                                        indeterminate={someSelected}
                                        onChange={handleSelectAll}
                                    />
                                }
                                label="Select All"
                            />
                        </Box>
                        <Divider />
                        <List>
                            {hiddenItems.map((item) => (
                                <ListItemButton key={item.id} onClick={() => handleToggle(item.id)} dense>
                                    <Checkbox
                                        edge="start"
                                        checked={selectedIds.indexOf(item.id) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                    <ListItemText
                                        primary={item.name || item.building_name || "Unnamed"}
                                    />
                                </ListItemButton>
                            ))}
                        </List>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={handleUnhide}
                    variant="contained"
                    disabled={selectedIds.length === 0}
                    sx={{
                        backgroundColor: "rgba(33, 150, 243, 0.9)",
                        "&:hover": { backgroundColor: "rgba(33, 150, 243, 1)" },
                    }}
                >
                    Unhide Selected ({selectedIds.length})
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnhideDialog;
